/* eslint-disable */
import React, { useState, useRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const InputContainerWrapper = styled.div`
    position: relative;
`;

const InputFieldWrapper = styled.div`
    border: ${props =>
        props.prefixContent || props.postfixContent
            ? props.error
                ? '1px solid #e3714d'
                : '1px solid #d8d8d8'
            : ''};
    border-radius: ${props => props.borderRadius};
    padding-left: ${props => props.prefixPadding};
`;

const InputWrapper = styled.input`
    background-image: ${props =>
        props.prefixIconUrl ? `url(${props.prefixIconUrl}) !important` : ''};
    background-position: ${props =>
        props.prefixIconUrl
            ? `${props.prefixPositionX} ${props.prefixPositionY}`
            : ''};
    background-repeat: ${props => (props.prefixIconUrl ? 'no-repeat' : '')};
    background-size: ${props =>
        props.prefixIconUrl
            ? `${props.prefixIconWidth} ${props.prefixIconHeight}`
            : ''};
    border: none;
    border: ${props =>
        !(props.prefixContent || props.postfixContent)
            ? props.error
                ? '1px solid #e3714d'
                : '1px solid #d8d8d8'
            : ''};
    font-size: 14px;
    height: 36px;
    padding-left: ${props => props.prefixPadding};
    padding-right: ${props => (props.showSubmitButton ? '55px' : '')};
    width: ${props => props.width};
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
        position: absolute;
        right: 0;
        height: 100%;
        width: 20px;
        opacity: 0;
        pointer-events: none;
    }
    &[type='number'] {
        -moz-appearance: textfield; /* Firefox */
    }
    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const ShowPasswordWrapper = styled.img`
    height: 18px;
    position: absolute;
    right: 15px;
    top: 14px;
    width: 18px;
`;

const SubmitWrapper = styled.p`
    opacity: ${props => (props.showSubmitButton ? '1' : '0')};
    position: absolute;
    right: ${props => (props.showSubmitButton ? '15px' : '0px')};
    top: 14px;
    transition: all0.3s ease-out;
`;

const RemoveButtonWrapper = styled.p`
    position: absolute;
    right: 15px;
    top: 14px;
`;

const InfoElementWrapper = styled.span`
    display: block;
    font-size: 12px;
    margin: 4px 0 0;
`;

const PostfixWrapper = styled.span`
    display: inline-block;
`;

const PrefixWrapper = styled.span`
    display: inline-block;
`;

const Input = props => {
    const {
        id,
        prefixContent = '',
        prefixIconUrl,
        postfixContent,
        showPasswordIconUrl,
        hidePasswordIconUrl,
        prefixIconWidth = '12px',
        prefixIconHeight = '12px',
        prefixPositionX = '18px',
        prefixPositionY = '14px',
        name,
        type,
        maxLength = '',
        placeholder,
        wrapperClass,
        borderRadius,
        prefixPadding,
        width = '100%',
        error,
        input,
        handleChange,
        handleBlur,
        handleFocus,
        handleReadOnlyClick,
        autocomplete = 'off',
        readOnly,
        disabled = false,
        hideErrors,
        showSubmitOnChange,
        submitComponent,
        showRemoveBtn,
        removeBtnComponent,
        rePositionErrors,
        rePositionErrorsElement,
        meta,
        pattern,
        infoElement,
        inputRef = useRef(null),
        min = '',
        max = '',
        step,
        accept,
        uppercase,
        maxDecimals
    } = props;

    const [passwordMaskIcon, setPasswordMaskIcon] = useState(
        showPasswordIconUrl
    );
    const [inputType, setInputType] = useState(type || 'text');
    const [showSubmitButton, setShowSubmitButton] = useState(false);

    function togglePassword() {
        if (passwordMaskIcon === showPasswordIconUrl) {
            setInputType('text');
            setPasswordMaskIcon(hidePasswordIconUrl);
        } else {
            setInputType('password');
            setPasswordMaskIcon(showPasswordIconUrl);
        }
    }

    function handleInputChange(event) {
        const formFieldChangeMethod =
            input && input.onChange
                ? input.onChange
                : handleChange
                ? handleChange
                : null;

        if (uppercase)
            event.target.value = event.target.value.toUpperCase();

         // Prevent input beyond maxLength
        if (maxLength && event.target.value.length > maxLength) {
            event.preventDefault();
            return;
        }

        // Handle maxDecimals for numbers
        if (typeof maxDecimals === 'number' && event.target.value) {
            const decimalRegex = new RegExp(`^\\d*(\\.\\d{0,${maxDecimals}})?$`);
            if (!decimalRegex.test(event.target.value)) {
                event.preventDefault();
                return;
            }
        }

        if (pattern) {
            if (event.target.value) {
                if (pattern.test(event.target.value)) {
                    formFieldChangeMethod
                        ? formFieldChangeMethod(event.target.value, event)
                        : '';
                } else {
                    event.preventDefault();
                }
            } else {
                formFieldChangeMethod
                    ? formFieldChangeMethod(event.target.value, event)
                    : '';
            }
        } else {
            formFieldChangeMethod
                ? formFieldChangeMethod(event.target.value, event)
                : '';
        }
    }

    function handleInputBlur() {
        input && input.onBlur ? input.onBlur() : '';
        handleBlur && handleBlur();
    }

    function handleInputFocus() {
        handleFocus && handleFocus();
    }

    function handleRemoveBtnClick() {
        setShowSubmitButton(false);
    }

    function handlePostfixClick() {
        inputRef.current.focus();
    }

    const handleWheel = event => {
        event.preventDefault();
        event.target.blur();
    };

    const inputComponent = (
        <InputWrapper
            type={inputType}
            name={name}
            maxLength={maxLength}
            min={min}
            max={max}
            step={step}
            id={id}
            placeholder={placeholder}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onFocus={handleInputFocus}
            width={
                (postfixContent || prefixContent) && input && input.value
                    ? `${input.value.length * 6 +
                          (prefixPadding || prefixIconUrl ? 43 : 13)}px`
                    : width
            }
            value={input && input.value}
            prefixIconUrl={prefixIconUrl}
            prefixIconWidth={prefixIconWidth}
            prefixIconHeight={prefixIconHeight}
            prefixPositionX={prefixPositionX}
            prefixPositionY={prefixPositionY}
            autoComplete={autocomplete}
            disabled={disabled}
            readOnly={readOnly}
            onClick={handleReadOnlyClick}
            showSubmitButton={showSubmitButton}
            ref={inputRef}
            prefixPadding={
                prefixContent && input && input.value
                    ? ''
                    : prefixPadding || prefixIconUrl
                    ? '43px'
                    : '13px'
            }
            prefixContent={prefixContent}
            postfixContent={postfixContent}
            accept={accept}
            onWheel={handleWheel}
        />
    );

    const passwordComponent = type === 'password' &&
        showPasswordIconUrl &&
        hidePasswordIconUrl && (
            <ShowPasswordWrapper
                src={passwordMaskIcon}
                alt={
                    passwordMaskIcon === showPasswordIconUrl
                        ? 'Show Password'
                        : 'Hide Password'
                }
                onClick={togglePassword}
            />
        );

    return (
        <InputContainerWrapper
            className={`input-container ${wrapperClass || ''}${
                error || (meta && meta.error && meta.touched) ? ' error' : ''
            }`}
        >
            {prefixContent || postfixContent ? (
                <InputFieldWrapper
                    postfixContent={postfixContent}
                    prefixContent={prefixContent}
                    borderRadius={borderRadius || '2px'}
                    prefixPadding={
                        prefixContent && input && input.value
                            ? prefixPadding || prefixIconUrl
                                ? '43px'
                                : '13px'
                            : ''
                    }
                    onClick={handlePostfixClick}
                    error={error || (meta && meta.error && meta.touched)}
                >
                    {input && input.value !== undefined && prefixContent && (
                        <PrefixWrapper>&nbsp;{prefixContent}</PrefixWrapper>
                    )}
                    {inputComponent}
                    {input && input.value !== undefined && postfixContent && (
                        <PostfixWrapper>&nbsp;{postfixContent}</PostfixWrapper>
                    )}
                    {passwordComponent}
                </InputFieldWrapper>
            ) : (
                <Fragment>
                    {inputComponent}
                    {passwordComponent}
                </Fragment>
            )}
            {showSubmitOnChange && submitComponent && !showRemoveBtn && (
                <SubmitWrapper
                    className="submit-wrap"
                    showSubmitButton={showSubmitButton}
                >
                    {submitComponent}
                </SubmitWrapper>
            )}
            {showSubmitOnChange && submitComponent && showRemoveBtn && (
                <RemoveButtonWrapper onClick={handleRemoveBtnClick}>
                    {removeBtnComponent}
                </RemoveButtonWrapper>
            )}
            {!hideErrors && !rePositionErrors && error && (
                <ErrorWrapper className="error-message">{error}</ErrorWrapper>
            )}
            {!hideErrors &&
                !rePositionErrors &&
                meta &&
                meta.touched &&
                meta.error && (
                    <ErrorWrapper className="error-message">
                        {meta.error}
                    </ErrorWrapper>
                )}
            {rePositionErrors &&
                rePositionErrorsElement &&
                error &&
                ReactDOM.createPortal(
                    <ErrorWrapper className="error-message">
                        {error}
                    </ErrorWrapper>,
                    rePositionErrorsElement
                )}
            {rePositionErrors &&
                rePositionErrorsElement &&
                meta &&
                meta.touched &&
                meta.error &&
                ReactDOM.createPortal(
                    <ErrorWrapper className="error-message">
                        {meta.error}
                    </ErrorWrapper>,
                    rePositionErrorsElement
                )}
            {infoElement && (
                <InfoElementWrapper>{infoElement}</InfoElementWrapper>
            )}
        </InputContainerWrapper>
    );
};

Input.propTypes = {
    className: PropTypes.string,
    defaultSelected: PropTypes.string,
    handleChange: PropTypes.func,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    wrapperClass: PropTypes.string,
};

export default Input;
